(function() {
    "use strict";

    angular.module("dashboardApp").directive("imsNavigationMenu", Directive);

    Directive.$inject = [
        '$document',
        '$timeout',
        'AppSettings'
    ];



    function Directive(
        $document,
        $timeout,
        AppSettings
    ) {


        function link($scope, element) {

            $scope.visible = false;


            $scope.toggleNavigationMenu = function() {
                $scope.visible = !$scope.visible;
            };


            element.find('.menu-item').on('click', function() {
                $timeout(function(){
                    $scope.visible = false;
                });
            });


            $document.mouseup(function(e) {
                if (elementHasTarget(e) && !isClickOnScrollbar(e)) {
                    $timeout(function() {
                        $scope.visible = false;
                    });
                }
            });


            function elementHasTarget(e) {
                return !element.is(e.target) && element.has(e.target).length === 0;
            }

            function isClickOnScrollbar(e) {
                // TODO: This is not checking for clicks on the scrollbar
                // but for clicks on the HTML document. FIX
                return e.target.toString().indexOf("HTMLHtmlElement") > -1;
            }



            function init() {
            }


            init();


        }



        return {
            restrict: 'E',
            replace: true,
            scope: {
            },
            templateUrl: AppSettings.paths.html + '/common/layout/navigation-menu.template.html',
            link: link
        };



    }


})();
